<script setup>
const personRecipes = inject('personRecipes')
</script>

<template>
	<span v-if="!personRecipes.length">
		<slot name="header" />
		<i class="text-muted">{{ $t('No recipes found.') }}</i>
	</span>
	<template v-else>
		<theme-base-swiper
			v-slot="slotProps"
			tag="section"
			:title="$t('Recipes')"
			title-classes="fw-bold mb-3"
			:items="personRecipes"
			:columns="{
				xs: 6,
				md: 3,
				lg: 2,
			}"
			url="/recepten"
			class="mb-5"
			inline
		>
			<theme-card-recipe
				tag="article"
				:item="slotProps.item"
			>
				<template #img="{ meta }">
					<thumbor-image
						:use="['sm', 'md']"
						:dimensions="{
							sm: [220, ratio(220, 1, 1.35)],
							md: [240, ratio(220, 1, 1.35)],
						}"
						:img="meta.imgSource"
						class="w-100 mb-0"
						:classes="{
							img: 'custom-card-img image-fluid bg-neutral-300 w-100',
						}"
						:img-alt="meta.imgAlt ?? null"
						:crop-preset="meta.imgCropping"
						filters="format(webp)"
					/>
				</template>
			</theme-card-recipe>
		</theme-base-swiper>
	</template>
</template>
